var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcYoutube = function SvgIcYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59px",
    height: "60px",
    viewBox: "0 0 59 60",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_youtube")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stopka",
    transform: "translate(-1705.000000, -79.000000)",
    fill: "#D5D4D3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_social",
    transform: "translate(1558.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.17,0.5 C192.19,0.5 205.14,13.75 205.14,30.17 C205.14,46.59 192.2,59.84 176.17,59.84 C160.14,59.84 147.19,46.58 147.19,30.17 C147.19,13.76 160.14,0.5 176.17,0.5 Z M178.257384,16.5708704 L174.082569,16.5708704 C158.560705,16.5911072 158.075647,17.0818496 158.060489,28.9823528 L158.060489,31.3576472 C158.075647,43.2581504 158.560705,43.7488928 174.082569,43.7691296 L178.256278,43.7691296 C193.769571,43.7488928 194.254362,43.2581504 194.269511,31.3576472 L194.269982,30.5739336 L194.269982,30.5739336 L194.27,30.17 C194.27,30.034 194.270001,29.89936 194.269985,29.7660664 L194.269537,28.9823528 C194.254921,17.0818496 193.778534,16.5911072 178.257384,16.5708704 Z M171.34,22.75 L183.41,30.17 L171.34,37.59 L171.34,22.75 Z",
    id: "ic_youtube"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_youtube.cba48789.svg";
export { ForwardRef as ReactComponent };